export const ADD_SUBJECT = "ADD_SUBJECT";
export const REMOVE_SUBJECT = "REMOVE_SUBJECT";
export const UPDATE_SUBJECT = "UPDATE_SUBJECT";
export const ADD_PERIOD = "ADD_PERIOD";
export const REMOVE_PERIOD = "REMOVE_PERIOD";
export const CLEAR_SUBJECTS = "CLEAR_SUBJECTS";
export const CLEAR_PERIODS = "CLEAR_PERIODS";
export const MARK_SW_WAITING = "MARK_SW_WAITING";
export const MARK_SW_NOT_WAITING = "MARK_SW_NOT_WAITING";
export const FLIP_TIME_TABLE = "FLIP_TIME_TABLE";
export const SET_EDITING_SUBJECT = "SET_EDITING_SUBJECT";
export const SET_EDITING_SUBJECT_DONE = "SET_EDITING_SUBJECT_DONE";